import { IEventAggregator, resolve, type IDisposable } from 'aurelia';
import { route } from '@aurelia/router';
import { IAuth } from './services/auth';
import { IClock } from './services/clock';
import { IConfig } from './services/config';
import { IDraws } from './services/draws';
import { IWallet } from './services/wallet';
import { ISound } from './services/sound';
import { IFirebase } from './services/firebase';
import { LoginPanel } from './components/login-panel';

@route({
  routes: [
    { id: 'play', path: ['', 'play'], component: () => import('./pages/play/play'), title: 'Play' },
    { id: 'results', path: 'results', component: () => import('./pages/results/results'), title: 'Results' },
    { id: 'wallet', path: 'wallet', component: () => import('./pages/wallet/wallet'), title: 'Wallet' },
    { id: 'fair', path: 'fair', component: () => import('./pages/fair/fair'), title: 'Provably fair' },
    { id: 'how', path: 'how-to-play', component: () => import('./pages/how/how'), title: 'How to play' },
    { path: '*path', redirectTo: '' },
  ],
})
export class MyApp {
  static dependencies = [LoginPanel];

  auth = resolve(IAuth);
  clock = resolve(IClock);
  config = resolve(IConfig);
  draws = resolve(IDraws);
  wallet = resolve(IWallet);
  sound = resolve(ISound);
  fb = resolve(IFirebase);
  ea = resolve(IEventAggregator);
  showLogin = false;
  private loginSub: IDisposable | null = null;
  menuOpen = false;
  private syncTimer: number | null = null;

  async binding(): Promise<void> {
    this.config.start();
    await this.clock.sync();
    this.draws.start();
    this.wallet.start();
    this.syncTimer = window.setInterval(() => void this.clock.sync(), 5 * 60_000);
    void this.auth.detectKeychain();
    this.loginSub = this.ea.subscribe('auth:open-login', () => this.openLogin());
  }

  unbinding(): void {
    this.draws.stop();
    this.wallet.stop();
    this.config.stop();
    if (this.syncTimer) clearInterval(this.syncTimer);
    this.loginSub?.dispose();
  }

  get playableTokens() {
    return this.config.tokens.filter((t) => t.enabled);
  }

  selectSymbol(symbol: string): void {
    this.wallet.setSymbol(symbol);
    this.sound.unlock();
    this.sound.bet();
    this.menuOpen = false;
  }

  openLogin(): void {
    this.sound.unlock();
    this.showLogin = true;
  }

  closeLogin(): void {
    this.showLogin = false;
  }

  async logout(): Promise<void> {
    this.menuOpen = false;
    await this.auth.logout();
  }

  toggleSound(): void {
    this.sound.toggle();
  }
}
